import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let HouseNoteFormComponent = {
    selector: "vcHouseNoteForm",
    templateUrl: "/angular/components/house/house-note.component.html",
    bindings: {
        houseNote: "=?",
    },
    controller: class HouseNoteFormController {
        // * bindings for typescript compiler *
        public houseNote?: any;
        // ************************************
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide(this.houseNote);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("house")
    .component(HouseNoteFormComponent.selector, HouseNoteFormComponent);
